/** Roles de minino (mismos ids que `RolUserEnum` de la API). */
export enum Role {
  /** Dueño de una empresa: todo dentro de su empresa, incluidas sus cuentas. */
  Admin = 1,
  /** Franquiciado/encargado: módulos de su empresa, solo sus sucursales asignadas. */
  Usuario = 4,
  /** Equipo de minino: empresas, cuentas y plantillas de video. Sin empresa. */
  SuperAdmin = 5,
}

export const ROLE_LABELS: Record<Role, string> = {
  [Role.Admin]: 'Administrador',
  [Role.Usuario]: 'Usuario',
  [Role.SuperAdmin]: 'SuperAdmin',
};
